import { render, staticRenderFns } from "./vue-cropper.vue?vue&type=template&id=f2270bc0&scoped=true&"
import script from "./vue-cropper.vue?vue&type=script&lang=ts&"
export * from "./vue-cropper.vue?vue&type=script&lang=ts&"
import style0 from "./vue-cropper.vue?vue&type=style&index=0&id=f2270bc0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2270bc0",
  null
  
)

export default component.exports